export class PromotionBean {
    constructor(info) {
      this.today_amounts = info.today_amounts ; //今日收益 
      this.yesterday_amounts = info.yesterday_amounts;//昨日收益
      this.current_month_amounts = info.current_month_amounts ;//本月收益
      this.last_month_amounts = info.last_month_amounts;//上月收益
    }
}